import jwtDecode from 'jwt-decode';

var isExpired = (function (encodedToken, refreshThreshold) {
  if (refreshThreshold === void 0) {
    refreshThreshold = 300;
  }

  var decodedToken = jwtDecode(encodedToken);
  var timeNow = Math.round(Date.now().valueOf() / 1000);
  var expiryTime = decodedToken.exp - timeNow;
  return expiryTime - refreshThreshold < 0;
});

export { isExpired as default };
//# sourceMappingURL=isExpired.js.map
